const DOMAIN_MAP = {
  'Albert Heijn': 'ah.nl',
  'Bol.com': 'bol.com',
  'Zalando': 'zalando.nl',
  'Coolblue': 'coolblue.nl',
  'MediaMarkt': 'mediamarkt.nl',
  'HEMA': 'hema.nl',
  'H&M': 'hm.com',
  'Spotify': 'spotify.com',
  'Netflix': 'netflix.com',
  'Etos': 'etos.nl',
  'Rituals': 'rituals.com',
  'Nike': 'nike.com',
  'Gall & Gall': 'gall.nl',
  'Thuisbezorgd': 'thuisbezorgd.nl',
  'ICI PARIS XL': 'iciparisxl.nl',
  'Douglas': 'douglas.nl',
  'Playstation Store': 'playstation.com',
  'de Bijenkorf': 'debijenkorf.nl',
};

const LOCAL_LOGO_MAP = {
  'Albert Heijn': '/logos/ah.webp',
  'Bol.com': '/logos/bol.webp',
  Coolblue: '/logos/coolblue.webp',
  Douglas: '/logos/douglas.webp',
};

const ACCENT_MAP = {
  'Albert Heijn': {
    backgroundClass: 'bg-[#eaf6ff]',
    textClass: 'text-[#0b67b2]',
    borderClass: 'border-[#bfddf6]',
  },
  'Bol.com': {
    backgroundClass: 'bg-[#eef3ff]',
    textClass: 'text-[#1d4ed8]',
    borderClass: 'border-[#bfdbfe]',
  },
  Coolblue: {
    backgroundClass: 'bg-[#e8f8ff]',
    textClass: 'text-[#0f6fa8]',
    borderClass: 'border-[#bae6fd]',
  },
  Douglas: {
    backgroundClass: 'bg-[#fff1f7]',
    textClass: 'text-[#be185d]',
    borderClass: 'border-[#fbcfe8]',
  },
};

export function getBrandLogo(brandName) {
  if (LOCAL_LOGO_MAP[brandName]) {
    return LOCAL_LOGO_MAP[brandName];
  }

  const domain = DOMAIN_MAP[brandName];

  if (domain) {
    return `https://img.logo.dev/${domain}?token=pk_bFm9xVw1T0uiR7QSlelnjg&size=80`;
  }

  const firstLetter = String(brandName || '?').charAt(0).toUpperCase();
  return `https://ui-avatars.com/api/?name=${firstLetter}&background=f97316&color=fff&size=80&bold=true`;
}

export function getBrandAccent(brandName) {
  return ACCENT_MAP[brandName] || {
    backgroundClass: 'bg-orange-100',
    textClass: 'text-orange-700',
    borderClass: 'border-orange-200',
  };
}
